import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface ProgressBarProgress {
  value: number;
  formatted?: string;
  colour: ProgressBarColour;
}

export enum ProgressBarColour {
  Positive,
  Neutral,
  Danger,
}

export const ProgressBarColourMapper = {
  bar: {
    [ProgressBarColour.Positive]: 'bg-grass-darker',
    [ProgressBarColour.Neutral]: 'bg-lemon-darker',
    [ProgressBarColour.Danger]: 'bg-rose-darker',
  },
  text: {
    [ProgressBarColour.Positive]: 'text-grass-darker',
    [ProgressBarColour.Neutral]: 'text-lemon-darker',
    [ProgressBarColour.Danger]: 'text-rose-darker',
  },
  difference: {
    [ProgressBarColour.Positive]: 'bg-grass-darker',
    [ProgressBarColour.Neutral]: 'bg-lemon-darker',
    [ProgressBarColour.Danger]: 'bg-rose-darker',
  },
};

export interface ProgressBar {
  title: string;
  progress: ProgressBarProgress;
  difference?: ProgressBarProgress;
}

@Component({
  selector: 'ui-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class ProgressBarComponent {
  @Input() progressBar: ProgressBar | undefined;

  ProgressBarColourMapper = ProgressBarColourMapper;
  ProgressBarColour = ProgressBarColour;
}
